module.exports = __webpack_public_path__ + "img/flexi_new_header.11624eef.svg";